import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-923b0828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-red-pack" }
const _hoisted_2 = { class: "create-container" }
const _hoisted_3 = { class: "create-main" }
const _hoisted_4 = { class: "account-info" }
const _hoisted_5 = { class: "create-form" }
const _hoisted_6 = { class: "form-label-container" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "form-input" }
const _hoisted_9 = { class: "form-input-amount" }
const _hoisted_10 = { class: "symbol" }
const _hoisted_11 = { class: "symbol-logo" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "symbol-name" }
const _hoisted_14 = { class: "form-label-container" }
const _hoisted_15 = { class: "form-label" }
const _hoisted_16 = { class: "form-input" }
const _hoisted_17 = { class: "form-label-container" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "form-input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_21 = { class: "create-handle" }
const _hoisted_22 = { class: "create-button" }
const _hoisted_23 = {
  key: 0,
  class: "allow-loading"
}
const _hoisted_24 = { class: "create-handle-button" }
const _hoisted_25 = { class: "button-step" }
const _hoisted_26 = { class: "create-handle-button" }
const _hoisted_27 = { class: "button-step" }
const _hoisted_28 = {
  key: 1,
  class: "create-handle-button"
}
const _hoisted_29 = { class: "create-ps" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!
  const _component_chain_tag = _resolveComponent("chain-tag")!
  const _component_account_connect = _resolveComponent("account-connect")!
  const _component_fx_input = _resolveComponent("fx-input")!
  const _component_loading = _resolveComponent("loading")!
  const _component_personality_button = _resolveComponent("personality-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_greeting_card, {
        greetings: _ctx.redPackData.title
      }, null, 8, ["greetings"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.chainId)
            ? (_openBlock(), _createBlock(_component_chain_tag, {
                key: 0,
                chainId: _ctx.chainId
              }, null, 8, ["chainId"]))
            : _createCommentVNode("", true),
          _createVNode(_component_account_connect, { address: _ctx.address }, null, 8, ["address"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.amount")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.balance", { amount: _ctx.$tools.amountFormat(_ctx.balance, _ctx.tokenInfo.decimals) })), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_fx_input, {
                modelValue: _ctx.redPackData.totalToken,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.redPackData.totalToken) = $event)),
                align: "left",
                placeholder: "0",
                isValid: _ctx.validatorStatus.totalToken.isValid,
                msg: _ctx.validatorStatus.totalToken.msg,
                onInput: _ctx.totalTokenInputHandler,
                onBlur: _ctx.totalTokenBlurHandler
              }, {
                append: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['max-tag', _ctx.maxStatus && 'max']),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setMaxAmount && _ctx.setMaxAmount(...args)))
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n('create.max')), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                          src: _ctx.tokenInfo.logo,
                          alt: ""
                        }, null, 8, _hoisted_12)
                      ]),
                      _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.tokenInfo.symbol), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "isValid", "msg", "onInput", "onBlur"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.number")), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_fx_input, {
                modelValue: _ctx.redPackData.number,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.redPackData.number) = $event)),
                type: "number",
                pattern: "[0-9]*",
                onBlur: _ctx.redPackNumberBlur
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(['icon', 'icon-minus', _ctx.redPackNumberChangeType === _ctx.redPackNumberRule.min && 'disabled']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redPackNumberHandler('minu')))
                  }, null, 2)
                ]),
                append: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(['icon', 'icon-plus',  _ctx.redPackNumberChangeType === _ctx.redPackNumberRule.max && 'disabled']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redPackNumberHandler('plus')))
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["modelValue", "onBlur"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.greetings")), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_fx_input, {
                modelValue: _ctx.redPackData.title,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.redPackData.title) = $event)),
                placeholder: _ctx.defaultTitle,
                style: {fontSize: '16px'},
                isValid: _ctx.validatorStatus.title.isValid,
                msg: _ctx.validatorStatus.title.msg,
                onInput: _ctx.titleInputHandler
              }, null, 8, ["modelValue", "placeholder", "isValid", "msg", "onInput"])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        (_ctx.tokenInfo.contract && _ctx.loading.allowance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_loading, { theme: "dark" })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.stepStatus)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_personality_button, {
                        type: "form",
                        loadingTheme: "dark",
                        disabled: !_ctx.sendStatus,
                        loading: _ctx.loading.approve,
                        onClick: _ctx.approve
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$checkI18n("create.approve")), 1),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$checkI18n("create.step", { step: 1 })), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_personality_button, {
                        type: "form",
                        loadingTheme: "dark",
                        disabled: _ctx.sendStatus || !_ctx.canISend,
                        loading: _ctx.sendLoading,
                        onClick: _ctx.createRedPack
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$checkI18n("create.send")), 1),
                          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$checkI18n("create.step", { step: 2 })), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_personality_button, {
                      type: "form",
                      loadingTheme: "dark",
                      loading: _ctx.sendLoading,
                      disabled: !_ctx.canISend,
                      onClick: _ctx.createRedPack
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$checkI18n("create.send")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ]))
            ], 64))
      ]),
      _createElementVNode("p", _hoisted_29, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$checkI18n("create.redPackPs")), 1)
      ])
    ])
  ]))
}